import * as React from "react";
import Layout from "../components/Layout/Layout";
import ProductsBlock from "../components/ProductsBlock/ProductsBlock";
import SEO from "../components/SEO/seo";


const Products = () => {
  return (
    <>
      <SEO title="Nawe Robotics | Products" description="Products build by Nawe Roboitcs Team" />
      <Layout>
        <ProductsBlock />
      </Layout>
    </>
  );
};

export default Products;
